import styled, { css } from 'styled-components'

const designerCSS = css`
  .show_trailing {
    display: flex;
    margin: 0 ;
    padding: 0;
  }
  .show_trailing {
    position: relative;
    flex-flow: column;
  }
  .show_trailing .max,
  .show_trailing .min {
    flex-direction: row;
    display: flex;
    margin: 0 0 10px 0;
    align-items: flex-start;
  }
  .show_trailing fieldset {
    margin: 5px 15px 0 0;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: fit-content;
  }
  .show_trailing .max fieldset:nth-child(2),
  .show_trailing .min fieldset:nth-child(2) {
    margin-right: 0;
  }
  .show_trailing fieldset span {
    font-size: 0.8rem;
    white-space: nowrap;
  }
  .show_trailing strong {
    font-weight: 600;
    font-size: 0.8rem;
    white-space: nowrap;
    padding: 0 4px;
  }
  .show_trailing .cancel_check {
    margin: 0 0 10px 0;
    padding: 5px 0 15px 0;
    justify-content: flex-start;
    display: flex;
    font-size: 0.8rem;
    align-items: center;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .show_trailing .cancel_check:last-child {
    border: 0;
  }
  .show_trailing input[type='text'] {
    background: var(--input-background);
    padding: 10px 0 10px 25px;
    border-radius: 10px;
    font-size: 0.8rem;
    margin-top: 5px;
    width: fit-content;
    max-width: 150px;
  }
  .show_trailing input[type='text']:disabled {
    cursor: not-allowed;
  }
  .show_trailing input[readonly] {
    background: transparent;
    padding-left: 0;
  }
  .show_trailing input[readonly].tpsl_result_data {
    font-weight: 800;
    max-width: 70px;
  }
  .show_trailing input[readonly].tpsl_result_data.profit {
    color: hsl(126, 100%, 38%);
  }
  .show_trailing input[readonly].tpsl_result_data.loss {
    color: hsla(340, 88%, 46%, 1);
  }
`
const developerCSS = css`
  .input_wrapper {
    position: relative;
    border-radius: 10px;
    font-size: 0.8rem;
    width: fit-content;
    max-width: 150px;
  }
  .input_wrapper.amount:after {
    position: absolute;
    left: 10px;
    top: 60%;
    transform: translate(0, -50%);
      content: '$';
      color: #ffffff5F;
    }
  .input_wrapper.percentage:after {
    position: absolute;
    left: 10px;
    top: 60%;
    transform: translate(0, -50%);
      content: '%';
      color: #ffffff5F;
    }
`

export const TrailingEditCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
